export default class Disclaimer {
  static selectorString() {
    return '.Disclaimer';
  }

  constructor(rootNode) {
    const closeLinks = rootNode.querySelectorAll('.action-close');

    if (!localStorage.getItem('educationalDisclaimer') || localStorage.getItem('educationalDisclaimer') !== 'true') {
      rootNode.classList.add('show');
    }

    closeLinks.forEach(function (el, k) {
      el.onclick = function (e) {
        localStorage.setItem('educationalDisclaimer', 'true');
        rootNode.classList.remove('show');
      };
    });
  }
}
